import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import QuotePage from "@/pages/QuotePage";
import InventoryLookup from "@/pages/InventoryLookup";
import ReservationConfirmation from "@/pages/ReservationConfirmation";
import CustomerPurchaseRequestResponse from "@/pages/CustomerPurchaseRequestResponse";
import PurchaseRequestsHub from "@/pages/PurchaseRequestsHub";
import PurchaseRequestDetail from "@/pages/PurchaseRequestDetail";
import WaitListSignup from "@/pages/WaitListSignup";
import WaitListManage from "@/pages/WaitListManage";
import WaitListHub from "@/pages/WaitListHub";
import POSLogin from "@/pages/POSLogin";
import POSDashboard from "@/pages/POSDashboard";
import POSTerminal from "@/pages/POSTerminal";
import QuotesHub from "@/pages/QuotesHub";
import QuoteDetail from "@/pages/QuoteDetail";
import InventoryAdmin from "@/pages/InventoryAdmin";
import CustomerQuoteResponse from "@/pages/CustomerQuoteResponse";
import AccountLookup from "@/pages/AccountLookup";
import MemberSignup from "@/pages/MemberSignup";
import MemberLookup from "@/pages/MemberLookup";
import MemberDetail from "@/pages/MemberDetail";
import OpenSchedule from "@/pages/OpenSchedule";
import Events from "@/pages/Events";
import TransactionsHub from "@/pages/TransactionsHub";
import TransactionDetail from "@/pages/TransactionDetail";
import TradeTerminal from "@/pages/TradeTerminal";
import { auth } from "@/lib/api";

function Protected({ children }) {
  if (!auth.isAuthed()) return <Navigate to="/pos" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" theme="dark" />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/quote" element={<QuotePage />} />
        <Route path="/inventory-lookup" element={<InventoryLookup />} />
        <Route path="/shop/reservation/:id" element={<ReservationConfirmation />} />
        <Route path="/purchase-request/:id/respond" element={<CustomerPurchaseRequestResponse />} />
        <Route path="/wait-list" element={<WaitListSignup />} />
        <Route path="/wait-list/:id" element={<WaitListManage />} />
        <Route path="/account-lookup" element={<AccountLookup />} />
        <Route path="/pos" element={<POSLogin />} />
        <Route path="/pos/dashboard" element={<Protected><POSDashboard /></Protected>} />
        <Route path="/pos/terminal" element={<Protected><POSTerminal /></Protected>} />
        <Route path="/pos/trade" element={<Protected><TradeTerminal /></Protected>} />
        <Route path="/pos/quotes" element={<Protected><QuotesHub /></Protected>} />
        <Route path="/pos/quotes/:id" element={<Protected><QuoteDetail /></Protected>} />
        <Route path="/pos/inventory" element={<Protected><InventoryAdmin /></Protected>} />
        <Route path="/pos/members" element={<Protected><MemberLookup /></Protected>} />
        <Route path="/pos/members/new" element={<Protected><MemberSignup /></Protected>} />
        <Route path="/pos/members/:phone" element={<Protected><MemberDetail /></Protected>} />
        <Route path="/pos/schedule" element={<Protected><OpenSchedule /></Protected>} />
        <Route path="/pos/events" element={<Protected><Events /></Protected>} />
        <Route path="/pos/transactions" element={<Protected><TransactionsHub /></Protected>} />
        <Route path="/pos/transactions/:id" element={<Protected><TransactionDetail /></Protected>} />
        <Route path="/pos/purchase-requests" element={<Protected><PurchaseRequestsHub /></Protected>} />
        <Route path="/pos/purchase-requests/:id" element={<Protected><PurchaseRequestDetail /></Protected>} />
        <Route path="/pos/wait-list" element={<Protected><WaitListHub /></Protected>} />
        <Route path="/quote/:id/respond" element={<CustomerQuoteResponse />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
